import { useEffect, useState } from 'react';

export default function LoadingScreen() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  if (!isLoading) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="relative w-20 h-20 mx-auto mb-6">
          <div className="absolute inset-0 border-4 border-[#1a4d2e]/20 rounded-full"></div>
          <div className="absolute inset-0 border-4 border-[#1a4d2e] rounded-full border-t-transparent animate-spin"></div>
        </div>
        <div className="text-[#1a4d2e] font-medium text-lg">
          ProEditions
        </div>
        <div className="text-gray-500 text-sm mt-2">
          Loading...
        </div>
      </div>
    </div>
  );
}
